module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card__status_wrapper"
  }, [_c('p', {
    staticClass: "card__status",
    class: ("card__status_" + (_vm.orderStatusConfig[_vm.item.status] ? _vm.orderStatusConfig[_vm.item.status].variant : "orange"))
  }, [_vm._v("Статус заявки на мероприятие: "), _c('b', [_vm._v(_vm._s(_vm.item.state_name))])]), (!_vm.item.is_hidden) ? _c('p', {
    staticClass: "show_hide",
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("Скрыть")]) : _vm._e()]), _c('div', {
    staticClass: "card__body"
  }, [_c('Picture', {
    staticClass: "card__image",
    attrs: {
      "copp": true,
      "src": _vm.item.img && _vm.item.img.small,
      "alt": _vm.item.title
    }
  }), (!_vm.item.isRequest) ? _c('h3', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.item.title))]) : _vm._e(), (_vm.item.isRequest) ? _c('h3', {
    staticClass: "card__title"
  }, [_vm._v("Заявка на разработку программы")]) : _vm._e(), _c('div', {
    staticClass: "card__text"
  }, [(_vm.item.date) ? _c('p', {
    staticClass: "card__data"
  }, [_vm._v("Заявка оформлена: "), _c('b', [_vm._v(_vm._s(_vm.item.date))])]) : _vm._e(), (_vm.item.schedule_dates) ? _c('p', {
    staticClass: "card__data"
  }, [_vm._v("Период обучения: "), _c('b', [_vm._v(_vm._s(_vm.item.schedule_dates.from) + " - " + _vm._s(_vm.item.schedule_dates.to))])]) : _vm._e(), (_vm.item.fio) ? _c('p', {
    staticClass: "card__data"
  }, [_vm._v("Обучающийся "), _c('b', [_vm._v(_vm._s(_vm.item.fio))])]) : _vm._e(), (_vm.item.status === "studying" || _vm.item.status === "approved") ? _c('p', {
    staticClass: "card__data"
  }, [_vm._v("Группа "), _c('b', [_vm._v(_vm._s(_vm.item.groupName))])]) : _vm._e(), (_vm.item.orderId) ? _c('p', {
    staticClass: "card__data"
  }, [_vm._v("Номер заявки: "), _c('b', [_vm._v(_vm._s(_vm.item.orderId))])]) : _vm._e(), (_vm.item.comment_for_client && !_vm.isOpenComment) ? _c('p', {
    staticClass: "card__data"
  }, [_c('span', {
    staticClass: "comment_open",
    on: {
      "click": function($event) {
        _vm.isOpenComment = !_vm.isOpenComment
      }
    }
  }, [_vm._v("Подробнее")])]) : _vm._e(), (_vm.isOpenComment) ? _c('p', {
    staticClass: "card__data"
  }, [_c('span', [_vm._v("Комментарий: ")]), _c('b', [_vm._v(_vm._s(_vm.item.comment_for_client))])]) : _vm._e(), (_vm.item.comment_for_client && _vm.isOpenComment) ? _c('p', {
    staticClass: "card__data"
  }, [_c('span', {
    staticClass: "comment_open",
    on: {
      "click": function($event) {
        _vm.isOpenComment = !_vm.isOpenComment
      }
    }
  }, [_vm._v("Свернуть")])]) : _vm._e()]), (_vm.item.message) ? _c('Message', {
    staticClass: "card__message",
    attrs: {
      "color": _vm.orderStatusConfig[_vm.item.status].variant
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.item.message))])]) : _vm._e(), _c('div', {
    staticClass: "card__controls"
  }, [(_vm.item.userCanCancel) ? _c('Cancellation', {
    on: {
      "cancel": function($event) {
        return _vm.$emit("cancel")
      }
    }
  }) : _vm._e(), _c('router-link', {
    staticClass: "card__link",
    attrs: {
      "to": _vm.routerRequest(_vm.item)
    }
  }, [_vm._v("Подробнее")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35132652","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/purchaseNewEventCard/PurchaseNewEventCard.vue
// module id = 3c7725bf39048c33fdea
// module chunks = 2